import { createContext, useState, useMemo } from 'react';
import { ModalWindow } from '../components/modal/Modal';

const ModalContext = createContext({
  modal: [],
  setModal: () => {}
});
ModalContext.displayName = 'ModalContext';

const initialModalState = {
  open: false,
  header: '',
  body: null,
  footer: null
};

export default function ModalCtxComponent(children) {
  const [modal, setModal] = useState(initialModalState);
  const handleModalCtx = obj => {
    setModal(prevState => ({ ...prevState, ...obj }));
  };
  const context = useMemo(() => ({ modal, setModal: handleModalCtx }), [modal]);

  return (
    <ModalContext.Provider value={context}>
      {children}
      <ModalWindow />
    </ModalContext.Provider>
  );
}

ModalCtxComponent.context = ModalContext;
